
type Props = { date: string, readingTime: Number };

function ArticleMetaData(props: Props) {
  const { date, readingTime } = props;

  const pubDate = new Date(Date.parse(date));

  const stringifyMonth = (givenDate: Date) => {
    let month: string = '';

    switch (givenDate.getMonth()) {
      case 0:
        month = 'Januar';
        break;
      case 1:
        month = 'Februar';
        break;
      case 2:
        month = 'März';
        break;
      case 3:
        month = 'April';
        break;
      case 4:
        month = 'Mai';
        break;
      case 5:
        month = 'Juni';
        break;
      case 6:
        month = 'Juli';
        break;
      case 7:
        month = 'August';
        break;
      case 8:
        month = 'September';
        break;
      case 9:
        month = 'Oktober';
        break;
      case 10:
        month = 'November';
        break;
      case 11:
        month = 'Dezember';
        break;
      default:
        month = 'Januar';
        break;
    }
    return month;
  };

  return (
    <div className='article-meta-data container'>
      <p>
        <span className='article-meta-data__date'>
          {`${pubDate.getDate()}. ${stringifyMonth(pubDate)} ${pubDate.getFullYear()}`}
        </span>{' '}
        |
        {' '}<span className='article-meta-data__reading-time'>
          Lesedauer <span className='duration'>{`${readingTime} Min`}</span>
        </span>
      </p>
    </div>
  );
}
export default ArticleMetaData;
